/* 路由配置 */
export const PART_TIME = '/part-time';  // 招聘页
export const FEEDBACK = '/feedBack';    // 意见反馈


/* 其他链接配置 */
export const SERVICE = 'https://qiankuwang.udesk.cn/im_client/?web_plugin_id=100652&group_id=134702';    // 人工客服
